import { useState, useMemo } from "react";

const allCities = [
  { name: "Minneapolis", route: "/minneapolis", tagline: "Twin Cities expedited passport services", highlights: ["Hennepin County coverage", "Serving St. Louis Park, Richfield"], badge: "Most Popular", status: "live" },
  { name: "St. Paul", route: "/st-paul", tagline: "Minnesota capital city passport processing", highlights: ["Ramsey County coverage", "Serving Maplewood, Roseville"], badge: "Most Popular", status: "live" },
  { name: "Rochester", route: "/rochester-mn", tagline: "Southeast Minnesota expedited passports", highlights: ["Olmsted County coverage", "Mayo Clinic area travelers"], badge: null, status: "live" },
  { name: "Duluth", route: "/duluth-mn", tagline: "North Shore passport services", highlights: ["St. Louis County coverage", "Serving Superior, Two Harbors"], badge: null, status: "live" },
  { name: "Bloomington", route: "/bloomington", tagline: "Mall of America area passport processing", highlights: ["Near MSP Airport", "Serving Edina, Richfield"], badge: null, status: "live" },
  { name: "Brooklyn Park", route: "/brooklyn-park", tagline: "Northwest metro passport services", highlights: ["Hennepin County coverage", "Serving Maple Grove, Osseo"], badge: null, status: "live" },
  { name: "Plymouth", route: "/plymouth-mn", tagline: "Western metro expedited passports", highlights: ["Hennepin County coverage", "Serving Wayzata, Medina"], badge: null, status: "live" },
  { name: "Maple Grove", route: "/maple-grove", tagline: "Northwest metro passport processing", highlights: ["Hennepin County coverage", "Serving Brooklyn Park, Osseo"], badge: null, status: "live" },
  { name: "Woodbury", route: "/woodbury", tagline: "East metro passport services", highlights: ["Washington County coverage", "Serving Oakdale, Lake Elmo"], badge: null, status: "live" },
  { name: "Eagan", route: "/eagan", tagline: "South metro expedited passports", highlights: ["Dakota County coverage", "Serving Burnsville, Apple Valley"], badge: null, status: "live" },
  { name: "Eden Prairie", route: "/eden-prairie", tagline: "Southwest metro passport services", highlights: ["Hennepin County coverage", "Serving Chanhassen, Shakopee"], badge: null, status: "live" },
  { name: "Burnsville", route: "/burnsville", tagline: "South metro passport processing", highlights: ["Dakota County coverage", "Serving Eagan, Apple Valley"], badge: null, status: "live" },
  { name: "Blaine", route: "/blaine", tagline: "North metro expedited passports", highlights: ["Anoka County coverage", "Serving Coon Rapids, Ham Lake"], badge: null, status: "live" },
  { name: "Lakeville", route: "/lakeville", tagline: "South metro passport services", highlights: ["Dakota County coverage", "Serving Farmington, Apple Valley"], badge: null, status: "live" },
  { name: "Minnetonka", route: "/minnetonka", tagline: "Western metro passport processing", highlights: ["Hennepin County coverage", "Serving Wayzata, Excelsior"], badge: null, status: "live" },
  { name: "St. Cloud", route: "/st-cloud", tagline: "Central Minnesota passport services", highlights: ["Stearns County coverage", "Serving Sartell, Waite Park"], badge: null, status: "live" },
  { name: "Edina", route: "/edina", tagline: "Southwest metro expedited passports", highlights: ["Hennepin County coverage", "Serving Richfield, Bloomington"], badge: null, status: "live" },
  { name: "Apple Valley", route: "/apple-valley", tagline: "South metro passport services", highlights: ["Dakota County coverage", "Serving Lakeville, Rosemount"], badge: null, status: "live" },
  { name: "St. Louis Park", route: "/st-louis-park", tagline: "West metro passport processing", highlights: ["Hennepin County coverage", "Serving Minneapolis, Golden Valley"], badge: null, status: "live" },
  { name: "Moorhead", route: "/moorhead", tagline: "West central Minnesota passport services", highlights: ["Clay County coverage", "Serving Fargo, Dilworth"], badge: null, status: "live" },
  { name: "Mankato", route: "/mankato", tagline: "South central Minnesota expedited passports", highlights: ["Blue Earth County coverage", "Serving North Mankato, Eagle Lake"], badge: null, status: "live" },
  { name: "Shakopee", route: "/shakopee", tagline: "Southwest metro passport services", highlights: ["Scott County coverage", "Serving Prior Lake, Chaska"], badge: null, status: "live" },
  { name: "Coon Rapids", route: "/coon-rapids", tagline: "North metro passport processing", highlights: ["Anoka County coverage", "Serving Blaine, Fridley"], badge: null, status: "live" },
  { name: "Maplewood", route: "/maplewood", tagline: "East metro passport services", highlights: ["Ramsey County coverage", "Serving St. Paul, Oakdale"], badge: null, status: "live" },
  { name: "Chanhassen", route: "/chanhassen", tagline: "Southwest metro expedited passports", highlights: ["Carver County coverage", "Serving Eden Prairie, Chaska"], badge: null, status: "live" },
  { name: "Richfield", route: "/richfield", tagline: "South metro passport services — closest suburb to MSP", highlights: ["Hennepin County coverage", "3 miles from MSP Airport"], badge: null, status: "live" },
  { name: "Roseville", route: "/roseville-mn", tagline: "North east metro passport processing", highlights: ["Ramsey County coverage", "Serving St. Paul, Little Canada"], badge: null, status: "live" },
  { name: "Inver Grove Heights", route: "/inver-grove-heights", tagline: "South east metro passport services", highlights: ["Dakota County coverage", "Serving South St. Paul, Newport"], badge: null, status: "live" },
  { name: "Andover", route: "/andover", tagline: "North metro expedited passports", highlights: ["Anoka County coverage", "Serving Blaine, Ramsey"], badge: null, status: "live" },
  { name: "Austin", route: "/austin-mn", tagline: "Southeast Minnesota passport services", highlights: ["Mower County coverage", "Serving Albert Lea, Owatonna"], badge: null, status: "live" },
  { name: "West St. Paul", route: "/west-st-paul", tagline: "South metro passport processing", highlights: ["Dakota County coverage", "Serving St. Paul, Inver Grove Heights"], badge: null, status: "live" },
  { name: "Northfield", route: "/northfield", tagline: "South central Minnesota passport services", highlights: ["Rice County coverage", "Serving Faribault, Dundas"], badge: null, status: "live" },
  { name: "Owatonna", route: "/owatonna", tagline: "South central Minnesota expedited passports", highlights: ["Steele County coverage", "Serving Faribault, Waseca"], badge: null, status: "live" },
  { name: "Brainerd", route: "/brainerd", tagline: "North central Minnesota passport services", highlights: ["Crow Wing County coverage", "Lakes area travelers"], badge: null, status: "live" },
  { name: "Winona", route: "/winona", tagline: "Southeast Minnesota passport processing", highlights: ["Winona County coverage", "Serving La Crosse, Red Wing"], badge: null, status: "live" },
  { name: "Faribault", route: "/faribault", tagline: "South central Minnesota passport services", highlights: ["Rice County coverage", "Serving Northfield, Owatonna"], badge: null, status: "live" },
  { name: "Bemidji", route: "/bemidji", tagline: "North central Minnesota expedited passports", highlights: ["Beltrami County coverage", "Lakes area, Bemidji State travelers"], badge: null, status: "live" },
  { name: "Willmar", route: "/willmar", tagline: "West central Minnesota passport services", highlights: ["Kandiyohi County coverage", "Serving Spicer, New London"], badge: null, status: "live" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function MinnesotaCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Minnesota Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Minnesota Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Minnesota</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Minnesota locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}